'use strict';

module.exports = function() {
    var eventCallBack = function(eventType) {
        var datalayer = window.tc_vars;
        if (_.isFunction(window.usabilla_live)) {
            datalayer.usabilla_exit_var = eventType.type === Odigeo.Events.mouseLeave ? 1 : 0;
            window.usabilla_live('data', {
                'custom': datalayer,
            });
        }
    };

    $('body').on(Odigeo.Events.mouseLeave + ' ' + Odigeo.Events.mouseEnter, eventCallBack);
};
